import useAgentData from '~/client/hooks/useAgentData';
import useRequestLoginEffect from './useRequestLoginEffect';

const useGameView = () => {
  useRequestLoginEffect();
  const { isDesktop } = useAgentData();
  return { isDesktop };
};

export default useGameView;
